module.exports = __webpack_public_path__ + "img/water.3b7aec1a.png";